export const bip = {
  label: "Biuletyn Informacji Publicznej",

  tooltip: null,

  href: "https://ckziuwyrzysk-bip.powiat.pila.pl/",

  external: true,

  visible: {
    desktop: true,
    mobile: true,
  },

  logo: {
    src: "/assets/images/logos/school-site/bip-logo-flat-height-45px.svg",
    size: "sm",

    // opcjonalne 28
    height: 28,

    offset: {
      x: 0,
      y: 2,
    },
  },
};